"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungConflict = void 0;
var LeitungConflict;
(function (LeitungConflict) {
    LeitungConflict["Einbauart"] = "Einbauart";
    LeitungConflict["MaxGeschwindigkeit"] = "MaxGeschwindigkeit";
    LeitungConflict["MaxBeschleunigung"] = "MaxBeschleunigung";
    LeitungConflict["MaxVerfahrweg"] = "MaxVerfahrweg";
    LeitungConflict["EnvironmentTemperatur"] = "EnvironmentTemperatur";
    LeitungConflict["EspoolUngeschirmteLeitungKeinTPEMantel"] = "EspoolUngeschirmteLeitungKeinTPEMantel";
    LeitungConflict["EspoolGeschirmteLeitungNichtEspoolReady"] = "EspoolGeschirmteLeitungNichtEspoolReady";
})(LeitungConflict = exports.LeitungConflict || (exports.LeitungConflict = {}));
//# sourceMappingURL=LeitungConflict.js.map